import { render } from "./SnackbarComponent.vue?vue&type=template&id=c70a9662&scoped=true"
import script from "./SnackbarComponent.vue?vue&type=script&lang=js"
export * from "./SnackbarComponent.vue?vue&type=script&lang=js"

import "./SnackbarComponent.vue?vue&type=style&index=0&id=c70a9662&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70a9662"]])

export default __exports__